import r from "react";
import { Flex as i } from "./index47.mjs";
import { Icon as g } from "./index52.mjs";
import { Link as R } from "./index43.mjs";
import e from "prop-types";
import b from "classnames";
import { Paragraph as f } from "./index58.mjs";
import { BANNER_TYPES as S, BANNER_BASE_CLASS as s } from "./index59.mjs";
import t from "./index60.mjs";
import { FLEX_ALIGN_ITEMS as T, FLEX_DIRECTION as y } from "./index50.mjs";
import { LINK_TYPES as k } from "./index45.mjs";
import { ICON_SIZES as N } from "./index54.mjs";
import { TYPOGRAPHY_SIZES as c, TYPOGRAPHY_WEIGHTS as O } from "./index46.mjs";
const P = ({ classes: o, type: l, backgroundColor: n }) => b([
  t[s],
  t[`${s}--${l}`],
  t[`${s}--${n}`],
  o
]), w = (o) => /* @__PURE__ */ r.createElement(
  m,
  {
    ...o,
    icon: "badges-and-alerts/warning",
    type: S.ERROR
  }
), m = ({
  backgroundColor: o,
  children: l,
  classes: n,
  description: d,
  icon: _,
  link: a,
  onDismiss: p,
  title: $,
  titleColor: E,
  type: L,
  style: A,
  "data-testid": C = "banner",
  buttons: u
}) => {
  const I = P({ classes: n, type: L, backgroundColor: o });
  return /* @__PURE__ */ r.createElement(
    i,
    {
      style: A,
      classes: I,
      alignItems: T.FLEX_START,
      "data-testid": C
    },
    _ ? /* @__PURE__ */ r.createElement(
      g,
      {
        classes: t[`${s}__icon`],
        size: N.SMALL,
        name: _
      }
    ) : null,
    /* @__PURE__ */ r.createElement(
      i,
      {
        classes: t[`${s}__placeholder`],
        direction: y.COLUMN
      },
      /* @__PURE__ */ r.createElement(
        f,
        {
          classes: b([
            t[`${s}__title`],
            E && t[`${s}__title--${E}`]
          ]),
          size: c.N1,
          weight: O.BOLD,
          margin: "0"
        },
        $
      ),
      d ? /* @__PURE__ */ r.createElement(
        f,
        {
          classes: t[`${s}__desc`],
          size: c.N1,
          margin: "0"
        },
        d
      ) : null,
      l || null,
      a ? /* @__PURE__ */ r.createElement(
        R,
        {
          classes: t[`${s}__link`],
          size: c.N1,
          href: a.url,
          type: k.UNDERLINED
        },
        a.label
      ) : null
    ),
    u ? /* @__PURE__ */ r.createElement(i, { classes: t[`${s}__buttons`] }, u) : null,
    p ? /* @__PURE__ */ r.createElement(
      g,
      {
        onClick: p,
        name: "actions/close-banner",
        classes: t[`${s}__close`],
        size: N.TINY,
        "data-testid": "close-banner"
      }
    ) : null
  );
};
m.propTypes = {
  classes: e.string,
  children: e.element,
  title: e.string,
  description: e.string.isRequired,
  link: e.shape({
    label: e.string,
    url: e.string
  }),
  onDismiss: e.func,
  type: e.oneOf(Object.values(S)),
  icon: e.string,
  backgroundColor: e.string,
  titleColor: e.string,
  style: e.object,
  buttons: e.element
};
m.defaultProps = {
  title: void 0,
  classes: void 0,
  link: void 0,
  icon: void 0,
  backgroundColor: void 0,
  type: void 0,
  onDismiss: void 0,
  style: {}
};
export {
  s as BANNER_BASE_CLASS,
  S as BANNER_TYPES,
  m as Banner,
  w as ErrorBanner,
  m as default
};
